// extracted by mini-css-extract-plugin
export default {"container":"DP-z","topReviewHeading":"EP-z","criticalReview":"FP-z","favorableReview":"GP-z","vsSeparator":"HP-z"};